import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const TypeWriter = ({
  texts,
  typingInterval = 100,
  cursorBlinkInterval = 500,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const [cursorVisible, setCursorVisible] = useState(true);
  const [isReversing, setIsReversing] = useState(false);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  useEffect(() => {
    const currentText = texts[currentTextIndex];
    const updateIndex = () => {
      if (!isReversing) {
        if (index < currentText.length) {
          setDisplayedText((prev) => prev + currentText[index]);
          setIndex(index + 1);
        } else {
          setIsReversing(true);
        }
      } else {
        if (index > 0) {
          setDisplayedText((prev) => prev.slice(0, -1));
          setIndex(index - 1);
        } else {
          setIsReversing(false);
          setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
        }
      }
    };

    const typingIntervalId = setInterval(updateIndex, typingInterval);
    const cursorBlinkIntervalId = setInterval(() => {
      setCursorVisible((vis) => !vis);
    }, cursorBlinkInterval);

    return () => {
      clearInterval(typingIntervalId);
      clearInterval(cursorBlinkIntervalId);
    };
  }, [
    texts,
    index,
    isReversing,
    currentTextIndex,
    typingInterval,
    cursorBlinkInterval,
  ]);

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ opacity: { duration: 0.5 } }}
    >
      {displayedText}
      <span style={{ opacity: cursorVisible ? 1 : 0 }}>|</span>
    </motion.span>
  );
};

export default TypeWriter;
